// ============================================================
// CENTRO DE CONTROL DEL SITIO
// ------------------------------------------------------------
// Este es el ÚNICO archivo que se toca para conectar la página.
// Nada de esto cambia el diseño.
// ============================================================

// ------------------------------------------------------------
// 1. WEBHOOK DEL FORMULARIO
// ------------------------------------------------------------
// Pega aquí la URL del Inbound Webhook de GoHighLevel:
//   GHL -> Automation -> Workflows -> nuevo workflow
//   -> Trigger "Inbound Webhook" -> copiar la URL
//
// Mientras esté vacío, el formulario NO se rompe: cae al plan B
// y abre WhatsApp con los datos del lead ya escritos. Para una
// demo eso funciona mejor que un webhook, porque el vendedor ve
// el lead llegar a su teléfono en vivo.
export const LEAD_WEBHOOK = ''

// Webhook del newsletter del pie. Mismo comportamiento: vacío
// significa que el correo no se guarda en ningún lado.
export const NEWSLETTER_WEBHOOK = ''

// ------------------------------------------------------------
// 2. PIXEL DE META
// ------------------------------------------------------------
// ID del dataset. Vacío = no se carga nada, cero peso extra.
// Con un ID, dispara PageView al entrar y Lead al enviar el
// formulario, que es el evento contra el que optimiza una campaña.
export const META_PIXEL_ID = ''

// ------------------------------------------------------------
// 3. METADATOS
// ------------------------------------------------------------
export const SITE = {
  title: 'Porsche North Miami | Ventas, Servicio y Financiamiento',
  description:
    'Inventario Porsche nuevo y Pre-Owned Certificado en North Miami. Atención personalizada en español, leasing, trade-in y servicio con técnicos certificados.',
  // Dejar vacío mientras sea maqueta. Al publicar en un dominio
  // real, poner la URL canónica aquí.
  canonical: '',
  // true = la página pide NO ser indexada por buscadores.
  // Déjalo en true mientras sea una demo privada.
  noindex: true,
}

// ------------------------------------------------------------
// 4. UTILIDADES INTERNAS
// ------------------------------------------------------------

/** Envía el lead al webhook. Devuelve true si el envío salió bien. */
export async function postToWebhook(
  url: string,
  payload: Record<string, unknown>,
): Promise<boolean> {
  if (!url) return false
  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        source: 'porsche-north-miami-web',
        submittedAt: new Date().toISOString(),
        pageUrl: typeof window !== 'undefined' ? window.location.href : '',
      }),
    })
    return res.ok
  } catch {
    return false
  }
}

/** Dispara un evento del pixel solo si hay un ID configurado. */
export function track(event: string, params?: Record<string, unknown>) {
  if (!META_PIXEL_ID) return
  const w = window as any
  if (typeof w.fbq === 'function') w.fbq('track', event, params)
}
